import type { AutomationConflict, AutomationEnableBlocked } from "../types/automation.types"

export type ErrorDetails = Record<string, unknown> & {
  message?: string
  error_codes?: Record<string, string[]>
}

// Validation errors arrive through the project's error handler as
// `{ details: { <field>: [..], error_codes } }`; a bare DRF body keeps the
// same keys at the top level.
export const readErrorDetails = (data: unknown): ErrorDetails => {
  const body = (data ?? {}) as { details?: ErrorDetails } & ErrorDetails
  return body.details && typeof body.details === "object" ? body.details : body
}

export const isConflict = (data: unknown): data is AutomationConflict =>
  (data as AutomationConflict | null)?.code === "conflict"

export const isEnableBlocked = (data: unknown): data is AutomationEnableBlocked =>
  (data as AutomationEnableBlocked | null)?.code === "enable_blocked"
